/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OauthRouteImport } from './routes/oauth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InviteIndexRouteImport } from './routes/invite/index'
import { Route as AuthSignupIndexRouteImport } from './routes/auth/signup/index'
import { Route as AuthLoginIndexRouteImport } from './routes/auth/login/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/auth/forgot-password/index'
import { Route as AuthOtpOriginNameRouteImport } from './routes/auth/otp/$origin-name'

const OauthRoute = OauthRouteImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteIndexRoute = InviteIndexRouteImport.update({
  id: '/invite/',
  path: '/invite/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupIndexRoute = AuthSignupIndexRouteImport.update({
  id: '/auth/signup/',
  path: '/auth/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/auth/login/',
  path: '/auth/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/auth/forgot-password/',
  path: '/auth/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOtpOriginNameRoute = AuthOtpOriginNameRouteImport.update({
  id: '/auth/otp/$origin-name',
  path: '/auth/otp/$origin-name',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/oauth': typeof OauthRoute
  '/invite': typeof InviteIndexRoute
  '/auth/otp/$origin-name': typeof AuthOtpOriginNameRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/signup': typeof AuthSignupIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/oauth': typeof OauthRoute
  '/invite': typeof InviteIndexRoute
  '/auth/otp/$origin-name': typeof AuthOtpOriginNameRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/signup': typeof AuthSignupIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/oauth': typeof OauthRoute
  '/invite/': typeof InviteIndexRoute
  '/auth/otp/$origin-name': typeof AuthOtpOriginNameRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/login/': typeof AuthLoginIndexRoute
  '/auth/signup/': typeof AuthSignupIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/oauth'
    | '/invite'
    | '/auth/otp/$origin-name'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/signup'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/oauth'
    | '/invite'
    | '/auth/otp/$origin-name'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/signup'
  id:
    | '__root__'
    | '/'
    | '/oauth'
    | '/invite/'
    | '/auth/otp/$origin-name'
    | '/auth/forgot-password/'
    | '/auth/login/'
    | '/auth/signup/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OauthRoute: typeof OauthRoute
  InviteIndexRoute: typeof InviteIndexRoute
  AuthOtpOriginNameRoute: typeof AuthOtpOriginNameRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthSignupIndexRoute: typeof AuthSignupIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/oauth': {
      id: '/oauth'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof OauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/': {
      id: '/invite/'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/': {
      id: '/auth/signup/'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login/': {
      id: '/auth/login/'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password/': {
      id: '/auth/forgot-password/'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/otp/$origin-name': {
      id: '/auth/otp/$origin-name'
      path: '/auth/otp/$origin-name'
      fullPath: '/auth/otp/$origin-name'
      preLoaderRoute: typeof AuthOtpOriginNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OauthRoute: OauthRoute,
  InviteIndexRoute: InviteIndexRoute,
  AuthOtpOriginNameRoute: AuthOtpOriginNameRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthSignupIndexRoute: AuthSignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
